<template>
  <ImportExport :title="$t('keywords.api_query')" type="consultaapilib" :headers="headers" v-on="$listeners">
    <template #item.nameGetMethod="{ item }">
      <v-text-field v-model="item.nameGetMethod" style="margin-bottom: -2.3vh" outlined dense :rules="alphaNumericRules(item.nameGetMethod)" />
    </template>

    <template #item.active="{ item }">
      <v-switch v-model="item.active" />
    </template>

    <template #item.routingkey="{ item }">
      <RoutingkeySelect v-model="item.routingkey" style="width: 10.5vw; margin-bottom: -3%" :rules="requiredRules(item.routingkey)" hint="" />
    </template>

    <template #item.listTenant="{ item }">
      <DatabaseSelect :label="$t('keywords.db')" required multiple v-model="item.listTenant" />
    </template>
  </ImportExport>
</template>

<script>
import ImportExport from '../core/ImportExport.vue'
import RoutingkeySelect from '../core/RoutingkeySelect.vue'
import { alphaNumericRules, requiredRules } from '../../utils/rules'
import DatabaseSelect from '../core/DatabaseSelect.vue'
import LocalStorageService from '../../services/LocalStorageService'

export default {

  components: { ImportExport, RoutingkeySelect, DatabaseSelect },

  data: () => ({
    alphaNumericRules,
    requiredRules
  }),

  computed: {
    headers () {
      return [
        {
          text: this.$t('keywords.method_name'),
          value: 'nameGetMethod'
        },
        {
          text: this.$t('check.active'),
          value: 'active'
        },
        {
          text: this.$t('core.routing_key'),
          value: 'routingkey',
          show: LocalStorageService.isPlatform()
        },
        {
          text: this.$t('keywords.db'),
          value: 'listTenant'
        }
      ].filter(i => i.show ?? true)
    }
  }

}
</script>
